var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-5" },
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("kickout.explain")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("kickout.explain2")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("kickout.contact")))]),
      _vm._v(" "),
      _c("base-button", { staticClass: "mt-2", on: { click: _vm.goToLogin } }, [
        _vm._v(_vm._s(_vm.$t("log-in")))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6faf576", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6faf576","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/Kickout.vue
// module id = 4150
// module chunks = 113